/*
 * Slides the cart's price breakdown open and shut.
 *
 * A native <details> snaps to its new height. This animates the height of the
 * body wrapper instead, and — when closing — holds `open` on until the
 * animation has finished, so the element still behaves like a <details> for
 * the keyboard and for screen readers.
 *
 * Bound by delegation on the document rather than on the summary itself:
 * Dawn re-renders the drawer's markup on every quantity change, and a handler
 * attached to the element would be thrown away with it.
 */
(function () {
  const SUMMARY = '.mc-cart__totals-summary';
  const BODY = '.mc-cart__details-body';
  const DURATION = 300;
  const EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  document.addEventListener('click', function (event) {
    const summary = event.target.closest(SUMMARY);
    if (!summary) return;

    const details = summary.closest('details');
    if (!details) return;

    const body = details.querySelector(BODY);
    // No wrapper, no Web Animations, or the visitor asked for less motion:
    // leave the browser to toggle it the plain way.
    if (!body || typeof body.animate !== 'function' || prefersReducedMotion()) return;

    event.preventDefault();
    if (details.dataset.mcAnimating) return;

    const opening = !details.open;
    details.dataset.mcAnimating = 'true';

    if (opening) {
      // Children of a closed <details> are not rendered, so it has to be open
      // before the target height can be measured.
      details.open = true;
    } else {
      // Flip the caret at the start of the close, not at the end of it.
      details.dataset.mcClosing = 'true';
    }

    const from = opening ? 0 : body.getBoundingClientRect().height;
    const to = opening ? body.scrollHeight : 0;

    body.style.overflow = 'hidden';

    const animation = body.animate(
      {
        height: [from + 'px', to + 'px'],
        opacity: opening ? [0, 1] : [1, 0],
      },
      { duration: DURATION, easing: EASING }
    );

    function settle() {
      body.style.overflow = '';
      delete details.dataset.mcAnimating;
      delete details.dataset.mcClosing;
      if (!opening) details.open = false;
    }

    animation.finished.then(settle, settle);
  });
})();
